'use client';

import { ClickAwayListener } from '@mui/material';
import { clsx } from 'clsx';
import { ChangeEvent, FC, useEffect, useRef, useState } from 'react';
import { SearchInput } from 'organisms/HeaderSearch/SearchInput';
import { parseCategories, parseKeywords } from 'pages/Search/api';
import { useSearch } from 'pages/Search/useSearch';
import { usePathname } from 'modules/next/hooks';
import { useSiteConfig } from 'modules/shop/siteConfig/hooks';
import {
  getSearchSuggestedCategories,
  getSearchSuggestedProducts,
} from 'commerce/factFinder/api';
import { getPreSearchProductsClient } from 'commerce/shop/client';
import { SearchPopup } from './SearchPopup';
import styles from './styles.module.css';

export const HeaderSearch: FC<{ className?: string }> = ({ className }) => {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const { categoriesMap, triggerSuggestionEvent } = useSiteConfig();
  const pathname = usePathname();
  const MAX_LENGTH = 5;

  const {
    state,
    handleSearchChange,
    areSuggestionsShown,
    handleSubmit,
    clear,
  } = useSearch({
    maxLength: MAX_LENGTH,
    api: {
      getPreSearchProductsClient: (query: string) => {
        return getPreSearchProductsClient(query, MAX_LENGTH);
      },
      getSearchSuggestedCategories: (query: string) => {
        const categories = getSearchSuggestedCategories(query);

        return parseCategories(categories, categoriesMap);
      },
      getSearchSuggestedProducts: (params) => {
        const keywords = getSearchSuggestedProducts({
          ...params,
          perPage: MAX_LENGTH,
        });

        return parseKeywords(keywords, params.query);
      },
    },
    isTablet: true,
  });

  useEffect(() => {
    if (isOpen) {
      clear();
    }
  }, [pathname]);

  const handleSearch = async (e: ChangeEvent<HTMLInputElement>) => {
    handleSearchChange(e);
    setIsOpen(true);
  };

  return (
    <div className={clsx(styles.root, className)} ref={ref}>
      <ClickAwayListener onClickAway={() => setIsOpen(false)}>
        <div>
          <SearchInput
            state={state}
            handleSearch={handleSearch}
            isOpen={isOpen && areSuggestionsShown}
            handleClose={() => setIsOpen(false)}
            handleOpen={() => setIsOpen(true)}
            handleSubmit={handleSubmit}
            clear={clear}
          />
          <SearchPopup
            open={isOpen && areSuggestionsShown}
            anchorEl={ref.current}
            state={state}
            triggerSuggestionEvent={triggerSuggestionEvent}
          />
        </div>
      </ClickAwayListener>
    </div>
  );
};
